import { useShowMessage } from '../providers'

type ReturnType = {
  showSuccess: (message: string) => void
  showError: (error?: string) => void
  showInfo: (message: string) => void
  showWarning: (message: string) => void
}

export const useMessage = (): ReturnType => {
  const showMessage = useShowMessage()

  const showSuccess = (message: string) => {
    showMessage({
      type: 'success',
      message
    })
  }

  const showError = (error = 'Something went wrong.') => {
    showMessage({
      type: 'error',
      message: error
    })
  }

  const showInfo = (message: string) => {
    showMessage({
      type: 'info',
      message
    })
  }

  const showWarning = (message: string) => {
    showMessage({
      type: 'warning',
      message
    })
  }

  return { showSuccess, showError, showInfo, showWarning }
}
